// Webhook configuration constants
export const PAYMENT_PLATFORMS = [
  { 
    value: 'hotmart', 
    label: 'Hotmart', 
    color: 'bg-orange-500',
    description: 'Maior plataforma de produtos digitais do Brasil',
    webhookUrl: '/api/payment-webhooks/hotmart'
  },
  { 
    value: 'kiwify', 
    label: 'Kiwify', 
    color: 'bg-purple-500',
    description: 'Plataforma de vendas de infoprodutos',
    webhookUrl: '/api/payment-webhooks/kiwify'
  },
  { 
    value: 'eduzz', 
    label: 'Eduzz', 
    color: 'bg-blue-500',
    description: 'Plataforma de afiliados e produtos digitais',
    webhookUrl: '/api/payment-webhooks/eduzz'
  },
  { 
    value: 'monetizze', 
    label: 'Monetizze', 
    color: 'bg-green-500',
    description: 'Plataforma de vendas online',
    webhookUrl: '/api/payment-webhooks/generic?platform=monetizze'
  },
  { 
    value: 'perfectpay', 
    label: 'PerfectPay', 
    color: 'bg-cyan-500',
    description: 'Gateway de pagamentos',
    webhookUrl: '/api/payment-webhooks/generic?platform=perfectpay'
  }
];

export const PLAN_TYPES = [
  { value: 'starter', label: 'Starter', clips: 10 },
  { value: 'individual', label: 'Individual', clips: 50 },
  { value: 'pro', label: 'Pro', clips: 300 },
  { value: 'enterprise', label: 'Enterprise', clips: 'Ilimitado' }
];

export const WEBHOOK_EVENTS = [
  { value: 'autopilot.created', label: 'Autopilot Criado', category: 'Autopilot' },
  { value: 'autopilot.started', label: 'Autopilot Iniciado', category: 'Autopilot' },
  { value: 'autopilot.paused', label: 'Autopilot Pausado', category: 'Autopilot' },
  { value: 'autopilot.stopped', label: 'Autopilot Parado', category: 'Autopilot' },
  { value: 'autopilot.cycle_completed', label: 'Ciclo Completado', category: 'Autopilot' },
  { value: 'clip.processed', label: 'Clip Processado', category: 'Clips' },
  { value: 'clip.scheduled', label: 'Clip Agendado', category: 'Clips' },
  { value: 'clip.published', label: 'Clip Publicado', category: 'Clips' },
  { value: 'clip.failed', label: 'Clip Falhou', category: 'Clips' },
  { value: 'viral.detected', label: 'Viral Detectado', category: 'Viral' },
  { value: 'viral.moment_found', label: 'Momento Viral Encontrado', category: 'Viral' },
  { value: 'analytics.post_viral', label: 'Post Viralizou (10k+)', category: 'Analytics' },
  { value: 'analytics.milestone', label: 'Milestone Alcançado', category: 'Analytics' }
];
